var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingFormActivateMemberFailur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 277,
    height: 515,
    viewBox: "0 0 277 515",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2640_3777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266 644.5C266 438.5 43.5 449.768 43.5 264C43.5 6.39288 50.5 0 -31 0",
    stroke: "#F9E9E2",
    strokeWidth: 26
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M277.5 650C277.5 410 56.9999 437 56.9999 275C56.9999 113 94 10 -8 10",
    stroke: "white",
    strokeWidth: 26
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2640_3777"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 277,
    height: 515,
    fill: "white",
    transform: "matrix(-1 0 0 1 277 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingFormActivateMemberFailur);
export default __webpack_public_path__ + "static/media/onboarding-form-activate-member-failur.557e635bf12f162a54cefa416e30b538.svg";
export { ForwardRef as ReactComponent };